module.exports = __webpack_public_path__ + "static/media/collapse.caaa851d.svg";